import React from 'react';
import { Router } from 'react-router-dom';
import history from './services/history';
import Routes from './services/Routers';
import ConfigProvider from './context/config/ConfigProvider';
import ApiProvider from './context/api/ApiProvider';

const App = () => {
  return (
    <ConfigProvider>
      <ApiProvider>
        <Router history={history}>
          <Routes />
        </Router>
      </ApiProvider>
    </ConfigProvider>
  );
};

export default App;
